import type { Template } from "@/types";

export const PO_07_H6_V1: Template[] = [
    {
        id: "po-07-h6v1-01",
        name: "PO 01 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_01.png",
        size: [1298, 827],
        style: {},
        slots: [           
            { id: "1", x: 47, y: 230, width: 287, height: 180, rotation: 0, imageRotation: 0 },
            { id: "2", x: 47, y: 418, width: 287, height: 179, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 230, width: 261, height: 367, rotation: 0, imageRotation: 0 },
            { id: "4", x: 696, y: 230, width: 275, height: 180, rotation: 0, imageRotation: 0 },
            { id: "5", x: 696, y: 418, width: 275, height: 179, rotation: 0, imageRotation: 0 },
            { id: "6", x: 979, y: 230, width: 274, height: 180, rotation: 0, imageRotation: 0 },
            { id: "7", x: 979, y: 418, width: 274, height: 179, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-02",
        name: "PO 02 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 50, y: 155, width: 547, height: 339, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 50, y: 501, width: 270, height: 170, rotation: 0, imageRotation: 0 },
            { id: "3", x: 328, y: 501, width: 270, height: 170, rotation: 0, imageRotation: 0 },
            { id: "4", x: 697, y: 155, width: 228, height: 167, rotation: 0, imageRotation: 0 },
            { id: "5", x: 697, y: 330, width: 228, height: 166, rotation: 0, imageRotation: 0 },
            { id: "6", x: 697, y: 504, width: 228, height: 166, rotation: 0, imageRotation: 0 },
            { id: "7", x: 933, y: 155, width: 313, height: 515, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-03",
        name: "PO 03 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 53, y: 183, width: 548, height: 341, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 53, y: 532, width: 178, height: 112, rotation: 0, imageRotation: 0 },
            { id: "3", x: 239, y: 532, width: 177, height: 112, rotation: 0, imageRotation: 0 },
            { id: "4", x: 424, y: 532, width: 177, height: 112, rotation: 0, imageRotation: 0 },
            { id: "5", x: 696, y: 127, width: 548, height: 331, rotation: 0, imageRotation: 0 },
            { id: "6", x: 696, y: 466, width: 369, height: 234, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1073, y: 466, width: 171, height: 234, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-04",
        name: "PO 04 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_04.png",
        size: [1298, 827],
        style: {},
        slots: [       
            { id: "1", x: 48, y: 120, width: 274, height: 191, rotation: 0, imageRotation: 0 },
            { id: "2", x: 48, y: 319, width: 274, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 48, y: 518, width: 274, height: 190, rotation: 0, imageRotation: 0 },
            { id: "4", x: 330, y: 120, width: 273, height: 191, rotation: 0, imageRotation: 0 },
            { id: "5", x: 330, y: 319, width: 273, height: 191, rotation: 0, imageRotation: 0 },
            { id: "6", x: 330, y: 518, width: 273, height: 190, rotation: 0, imageRotation: 0 },
            { id: "7", x: 763, y: 120, width: 420, height: 588, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-05",
        name: "PO 05 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 61, y: 213, width: 288, height: 197, rotation: 0, imageRotation: 0 },
            { id: "2", x: 61, y: 418, width: 288, height: 196, rotation: 0, imageRotation: 0 },
            { id: "3", x: 357, y: 213, width: 288, height: 197, rotation: 0, imageRotation: 0 },         
            { id: "4", x: 653, y: 213, width: 288, height: 401, rotation: 0, imageRotation: 0 },
            { id: "5", x: 357, y: 418, width: 288, height: 196, rotation: 0, imageRotation: 0 },
            { id: "6", x: 949, y: 213, width: 288, height: 197, rotation: 0, imageRotation: 0 },
            { id: "7", x: 949, y: 418, width: 288, height: 196, rotation: 0, imageRotation: 0 }
           
        ],
    },

    {
        id: "po-07-h6v1-06",
        name: "PO 06 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_06.png",
        size: [1298, 827],
        style: {},
        slots: [         
            { id: "1", x: 100, y: 109, width: 445, height: 301, rotation: 0, imageRotation: 0 },
            { id: "2", x: 100, y: 418, width: 445, height: 301, rotation: 0, imageRotation: 0 },
            { id: "3", x: 553, y: 109, width: 409, height: 610, rotation: 0, imageRotation: 0 },
            { id: "4", x: 970, y: 109, width: 229, height: 147, rotation: 0, imageRotation: 0 },
            { id: "5", x: 970, y: 264, width: 229, height: 147, rotation: 0, imageRotation: 0 },
            { id: "6", x: 970, y: 419, width: 229, height: 146, rotation: 0, imageRotation: 0 },
            { id: "7", x: 970, y: 573, width: 229, height: 146, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-07",
        name: "PO 07 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_07.png",
        size: [1298, 827],
        style: {},
        slots: [           
            { id: "1", x: 48, y: 127, width: 281, height: 186, rotation: 0, imageRotation: 0 },
            { id: "2", x: 48, y: 321, width: 281, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 48, y: 515, width: 281, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 337, y: 127, width: 366, height: 574, rotation: 0, imageRotation: 0 },
            { id: "5", x: 711, y: 127, width: 538, height: 374, rotation: 0, imageRotation: 0 },
            { id: "6", x: 711, y: 509, width: 265, height: 192, rotation: 0, imageRotation: 0 },
            { id: "7", x: 984, y: 509, width: 265, height: 192, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-08",
        name: "PO 08 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 70, y: 161, width: 351, height: 506, rotation: 0, imageRotation: 0 },
            { id: "2", x: 429, y: 161, width: 261, height: 164, rotation: 0, imageRotation: 0 },
            { id: "3", x: 429, y: 333, width: 261, height: 163, rotation: 0, imageRotation: 0 },
            { id: "4", x: 429, y: 504, width: 261, height: 163, rotation: 0, imageRotation: 0 },
            { id: "5", x: 698, y: 504, width: 261, height: 163, rotation: 0, imageRotation: 0 },
            { id: "6", x: 967, y: 504, width: 261, height: 163, rotation: 0, imageRotation: 0 },
            { id: "7", x: 698, y: 161, width: 530, height: 335, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-09",
        name: "PO 09 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 70, y: 161, width: 351, height: 506, rotation: 0, imageRotation: 0 },
            { id: "2", x: 429, y: 504, width: 261, height: 163, rotation: 0, imageRotation: 0 },
            { id: "3", x: 698, y: 504, width: 261, height: 163, rotation: 0, imageRotation: 0 },
            { id: "4", x: 967, y: 161, width: 260, height: 164, rotation: 0, imageRotation: 0 },
            { id: "5", x: 967, y: 333, width: 260, height: 163, rotation: 0, imageRotation: 0 },
            { id: "6", x: 967, y: 504, width: 260, height: 163, rotation: 0, imageRotation: 0 },
            { id: "7", x: 429, y: 161, width: 530, height: 335, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h6v1-10",
        name: "PO 10 - H6V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h6_v1_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 70, y: 161, width: 531, height: 335, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 70, y: 503, width: 262, height: 164, rotation: 0, imageRotation: 0 },
            { id: "3", x: 340, y: 503, width: 261, height: 164, rotation: 0, imageRotation: 0 },
            { id: "4", x: 609, y: 161, width: 350, height: 506, rotation: 0, imageRotation: 0 },
            { id: "5", x: 967, y: 161, width: 260, height: 164, rotation: 0, imageRotation: 0 },
            { id: "6", x: 967, y: 333, width: 260, height: 163, rotation: 0, imageRotation: 0 },
            { id: "7", x: 967, y: 504, width: 260, height: 163, rotation: 0, imageRotation: 0 }
        ],
    }
];